module.exports = __webpack_public_path__ + "media/images/proof_links/kinopoisk-2fa6d5aad6d6442b7f31b8fbfeada0d9.svg";